<div class="container">
     <div class=" py-2 px-3 my-4">
       <h2 class="slideOff">
          <i class="fa fa-address-book" aria-hidden="true"></i> Contacts
       </h2>
     </div>
   </div>
   <div class="mt-4">
     <table class="table table-striped table-bordered">
       <thead>
         <tr>
           <th>#</th>
           <th>Name</th>
           <th>Email</th>
           <th>City</th>
           <th>Phone</th>
           <th>Birth year</th>
         </tr>
       </thead>
       <tbody>
         <tr *ngFor="let item of _ar; let i = index">
           <td>
             {{i + 1}}
           </td>
           <td>{{item.name}}</td>
           <td>{{item.email}}</td>
           <td>{{item.city}}</td>
           <td>{{item.phone}}</td>
           <td>{{item.birth}}</td>
         </tr>
       </tbody>
     </table>
   </div>